// hooks/useCommentsHydration.ts — fetch a post's comments into commentStore (B4a retro-fix).
//
// Growth slice (1.21.60): GET /api/posts/<id>/comments/ is now public — a signed-out
// visitor reading a shared post must see its comment thread too, not just a signed-in one.

import { useEffect } from 'react';
import { commentsService } from '@/core/services/commentsService';

export function useCommentsHydration(postId: string): void {
  useEffect(() => {
    if (!postId) return;
    void commentsService.topLevelForPost(postId).catch(() => {});
  }, [postId]);
}
